"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageChangeHandlerSymbol = void 0;
exports.LanguageChangeHandlerSymbol = Symbol('LanguageChangeHandlerSymbol');
//# sourceMappingURL=languageChangeHandler.js.map